import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
// Logged-in users default to Dutch; public pages default to English when no preference is stored.
const savedLocale = localStorage.getItem("locale");
const locale =
  savedLocale ||
  (localStorage.getItem("userToken") ? "nl" : "en");
if (!savedLocale && localStorage.getItem("userToken") && locale === "nl") {
  localStorage.setItem("locale", "nl");
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: "nl",
  messages: {
    en: {
      message: {
        hello: "hello world",
        greeting: "good morning",
        login_success: "Hi {email}, you are successfully logged in as {role}",
        login_error:"Unable to log in with provided credentials.",
        saved_error: "Something went wrong",
        quantity: "Quantity",
        price_per: "Price Per",
        invoice_amount: "Invoice Amount",
        lead_fee: "Lead Fee",
        brand: "Brand",
        model: "Model",
        send_to_customer: "Send to Review",
      },
    },
    nl: {
      message: {
        hello: "こんにちは、世界",
        greeting: "おはようございます",
        login_success: "Hoi {email}, je bent succesvol ingelogd als {role}",
        login_error:"Kan niet inloggen met de opgegeven inloggegevens.",
        saved_error: "Er is iets misgegaan",
        quantity: "Hoeveelheid",
        price_per: "Prijs Per",
        invoice_amount: "Factuurbedrag",
        lead_fee: "Lead Fee",
        brand: "Merk",
        model: "Model",
        send_to_customer: "Versturen voor beoordeling",
      },
    },
  },
});

export default i18n;
